import React, { ComponentProps } from 'react'
import SvgIcon from '@mui/material/SvgIcon'

export const Calendar = ({ width = 24, height = 24, ...restProps }: ComponentProps<typeof SvgIcon>) => (
  <SvgIcon {...restProps} viewBox={`0 0 ${width} ${height}`}>
    <path
      d="M19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4H7V2H9V4H15V2H17V4H19C19.5304 4 20.0391 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22ZM5 10V20H19V10H5ZM5 6V8H19V6H5ZM17 18H15V16H17V18ZM13 18H11V16H13V18ZM9 18H7V16H9V18ZM17 14H15V12H17V14ZM13 14H11V12H13V14ZM9 14H7V12H9V14Z"
      fill="#424242"
    />
  </SvgIcon>
)
